import React, { Component } from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import { ImmutableLoadingBar as LoadingBar } from 'react-redux-loading-bar'

import Notification from './Notification'
import TopNav from './TopNav'
import RoleName from './RoleName'
import ProfileDropdown from './ProfileDropdown'
import MainLogo from './MainLogo'
import NotificationBar from './NotificationBar'
import { MICROACTIONS_PATH, subNavLinks, REVIEWS_PATH, navReviewsLinks } from 'app/constants/navLinks'
import { MAX_TABLET_DEVICE_WIDTH } from 'app/constants/screenSizes'
import OnboardingChecklist from 'app/domains/routes/Dashboard/OnboardingChecklist'

import './styles.scss'

const baseClass = 'top-block'
export class Header extends Component {
  static propTypes = {
    setHeight: PropTypes.func.isRequired,
    showReactions: PropTypes.bool,
    showPeerInvites: PropTypes.bool,
    navLinks: PropTypes.array.isRequired,
    isReviewsAvailable: PropTypes.bool,
    isSuperAdmin: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isMultiAdmin: PropTypes.bool.isRequired,
    windowWidth: PropTypes.number.isRequired,
  }

  static defaultProps = {
    isReviewsAvailable: false,
  }

  componentDidMount() {
    this.resize = debounce(() => this.forceUpdate(), 500)
    window.addEventListener('resize', this.resize)
    this.updateHeight()
  }

  componentWillUnmount() {
    this.props.setHeight(0)
    if (this.resize) {
      window.removeEventListener('resize', this.resize)
    }
  }

  componentDidUpdate() {
    this.updateHeight()
  }

  updateHeight = () => {
    setTimeout(() => {
      if (this && this.header && this.header.clientHeight) {
        this.props.setHeight(this.header.clientHeight)
      }
    }, 200)
  }

  render() {
    const {
      showReactions,
      navLinks,
      location: { pathname },
      isReviewsAvailable,
      isMicroActionsAvailable,
      isSuperAdmin,
      isMultiAdmin,
      isAdmin,
      isSuperOrMultiAdmin,
      // isUser,
      windowWidth,
    } = this.props

    // const isMobile = windowWidth <= MAX_TABLET_DEVICE_WIDTH

    const isShowTopNavSubMenu =
      isReviewsAvailable && ((isAdmin && isMicroActionsAvailable) || isSuperAdmin || isMultiAdmin)
    return (
      <div className={baseClass} ref={node => (this.header = node)}>
        <Notification />
        <header className="header">
          <ProfileDropdown />
          {showReactions && <NotificationBar />}
          {pathname.indexOf(MICROACTIONS_PATH) !== -1 && <TopNav links={navLinks} />}
          {isSuperOrMultiAdmin && pathname.indexOf(REVIEWS_PATH) !== -1 && <TopNav links={navReviewsLinks} />}
          <MainLogo />
          <RoleName />
          {false && <OnboardingChecklist />}
          {isShowTopNavSubMenu && <TopNav links={subNavLinks} floatLeft partialMatch />}
          <LoadingBar className={`${baseClass}__loading-bar`} progressIncrease={5} />
        </header>
      </div>
    )
  }
}

export default Header
